import React from 'react';
import { useShowContextRequired } from 'ui-builder';
import { Project, TotalTasks } from 'nekst-api';

import styles from './TotalTasksField.module.scss';
import { useProjectStatisticContextRequired } from 'features/tasks-forms';

function TotalTasksLayout(props: { value: TotalTasks }) {
  return (
    <div className={styles.field}>
      <span className={styles.active} title="Total Tasks Due Today">{props.value.active}</span>
      {' / '}
      <span className={styles.pastDue} title="Total Past Due Tasks">{props.value.pastDue}</span>
      {' / '}
      <span title="Total Tasks Upcoming">{props.value.all}</span>
    </div>
  );
}

export function StatisticTotalTasks() {
  const statistic = useProjectStatisticContextRequired().statistic;

  if (statistic) {
    return (
      <TotalTasksLayout value={statistic.totalTasks} />
    );
  } else {
    return null;
  }

}

export default function TotalTasksField(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,react/no-unused-prop-types
  props: { label: string },
) {
  const showContext = useShowContextRequired<Project>();

  const value = showContext.data.statistic?.totalTasks;

  if (value) {
    return (
      <TotalTasksLayout value={value} />
    );
  } else {
    return null;
  }
}
